export const ACCESS_KEY_ACTIONS = {
  FETCH_ACCESS_KEY: 'fetchAccessKey',
  UPDATE_ACCESS_KEY: 'updateAccessKey'
} as const

export type AccessKeyActionsType = (typeof ACCESS_KEY_ACTIONS)[keyof typeof ACCESS_KEY_ACTIONS]
